import {LogOut, Bell, User, Settings} from "lucide-react";
import {useState} from "react";
import {useUserStore} from "../../store/userStore";
import service from "../../api/FetchInterceptor";

export const Header = () => {
    const { user } = useUserStore();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const logout = () => {
        service({
            method: "POST",
            url: `auth/logout`
        }).then((response) => {

        })
    }

    return (
        <header className="fixed top-0 left-0 right-0 text-white p-2 z-50 bg-white border-b h-16">
            <div className="mx-4 h-full">
                <div className="flex flex-row justify-between items-center h-full">
                    <div className="w-20" />

                    <div className="flex items-center space-x-4">
                        <button className="p-2 hover:bg-gray-100 rounded-full">
                            <Bell className="h-5 w-5 text-gray-600"/>
                        </button>
                        <div className="relative">
                            <button
                                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                className="flex items-center space-x-2 p-2 hover:bg-gray-100 rounded-lg"
                            >
                                <div className="bg-blue-100 p-2 rounded-full">
                                    <User className="h-5 w-5 text-blue-600"/>
                                </div>
                                <div className="text-left">
                                    <div className="font-medium text-gray-900">{user.name}</div>
                                    {/*<div className="text-sm text-gray-500">{user.roles.map((role) => role.label)}</div>*/}
                                </div>
                            </button>

                            {isDropdownOpen && (
                                <div
                                    className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                                    <div className="px-4 py-3 border-b border-gray-100">
                                        <div className="flex items-center space-x-3">
                                            <div className="bg-gray-200 p-2 rounded-full">
                                                <User className="h-5 w-5 text-gray-600"/>
                                            </div>
                                            <div>
                                                <div className="font-medium text-gray-900">{user.name}</div>
                                                {/*<div className="text-sm text-gray-500">{user.roles.map((role) => role.label).join(", ")}</div>*/}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="py-2">
                                        <button
                                            onClick={logout}
                                            className="w-full px-4 py-2 text-left hover:bg-gray-50 flex items-center space-x-3 text-red-600">
                                            <LogOut className="h-4 w-4" />
                                            <span>Déconnexion</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}